import React from 'react'
import { Button, TableCell, TableRow } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { green, red } from '@mui/material/colors'
import BlockIcon from '@mui/icons-material/Block'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const StoreCreditList = ({ storeCredit }) => {
    const navigate = useNavigate()
    return (
        <TableRow>
            <TableCell>{storeCredit.customer.company}</TableCell>
            <TableCell>{storeCredit.payType}</TableCell>
            <TableCell>${storeCredit.creditAmount}</TableCell>
            <TableCell>{storeCredit?.creditDate}</TableCell>
            <TableCell align="center">
                {storeCredit.confirm ? (
                    <CheckCircleOutlineIcon style={{ color: green[500] }} />
                ) : (
                    <BlockIcon style={{ color: red[500] }} />
                )}
            </TableCell>
            <TableCell>
                <div className="button-box">
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() =>
                            navigate(`/store-credit/${storeCredit.id}`)
                        }
                    >
                        Info
                    </Button>
                </div>
            </TableCell>
        </TableRow>
    )
}

export default StoreCreditList
